export function EditCourseModal({ course, isSaving, onClose, onSubmit  }) { // fonction pour le modal de l'édit d'un cours pour rendre la page admin moins grosse et facile à modifier.
  return (
    <div className="modal-overlayAdmin">
      <div className="modal-contentAdmin">
        <div className="modal-header">
          <h3>Selected course : <span>{course.title}</span></h3>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        <form className="modal-form" onSubmit={onSubmit}>
          <div className="Section_title">
            <div className="form-group">
              <label>Title</label>
              <input name="title" maxLength="50" type="text" defaultValue={course.title} required />
            </div>
            <div className="form-group">
              <label>Icon</label>
              <input name="icon" type="text" placeholder="Ex: 📘" defaultValue={course.icon} required />
            </div>
          </div>
          <div className="form-group">
            <label>Short Description</label>
            <input name="description" type="text" defaultValue={course.details.description} required />
          </div>
          <div className="form-group">
            <label>Approach</label>
            <textarea name="approach" rows="5" maxLength="1000" defaultValue={course.details.approach} required />
          </div>
          <div className="form-group">
            <label>Subjects (separated by commas)</label>
            <input name="subjects" type="text" defaultValue={course.details.subjects} required />
          </div>
          <div className="form-group">
            <label>Status</label>
            <select name="status" defaultValue={course.status}>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
          <div className="modal-footer">
            <button className="btn-cancel" type="button" onClick={onClose}><span>Cancel</span></button>
            <button type="submit" className="btn-save" disabled={isSaving}>
              <span>{isSaving ? "Processing..." : "Save changes"}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}